import { useDispatch } from 'react-redux';
import '../../css/base.css';
import { setActivity } from '../../store/AppSlice';

const WalkLochans = () => {

  const dispatch = useDispatch();

  const navigateToActivity = () => {
    dispatch(setActivity("LOCHANS"));
  }

  return (
    <div>
      <h2 className="walks-link-heading"><a  onClick={navigateToActivity}>Gleann Dubh Lochain</a></h2>        
      <p className="walk-text">A peaceful walk along the Glen Arnisdale with its meandering river. Then a steep climb up to the head of the Glen and the two lochans.  
      </p>   
    </div>
  );
}

export default WalkLochans
